import { useIntl } from 'react-intl';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { GroupListMessages } from '../GroupList.messages';
import { yupResolver } from '@hookform/resolvers/yup';
import { CreateGroupFormData } from '../modals/CreateGroupModal/CreateGroupModal.types';

type UseGroupForm = () => UseFormReturn<CreateGroupFormData>;

export const useGroupForm: UseGroupForm = () => {
  const intl = useIntl();
  const groupValidationSchema = yup.object().shape(
    {
      name: yup
        .string()
        .required(intl.formatMessage(GroupListMessages.nameRequiredError))
        .min(2, 'Group name must be at least 2 characters long')
        .max(255, 'Group name can not be longer than 255 characters'),
      description: yup
        .string()
        .required(intl.formatMessage(GroupListMessages.descriptionRequiredError))
        .min(2, 'Description must be at least 2 characters long')
        .max(255, 'Description can not be longer than 255 characters'),
      id: yup
        .string()
        .notRequired()
        .when('id', {
          is: (val: string | null | undefined) => val?.length,
          then: (rule) => rule.max(255, 'ID can not be longer than 255 characters'),
        }),
    },
    [['id', 'id']],
  );

  return useForm<CreateGroupFormData>({
    resolver: yupResolver(groupValidationSchema),
    mode: 'onChange',
  });
};
